import React from "react"

import { ContentProps } from "@/components/Dialog/protocols"

import { Grid2 } from "@mui/material"

export const Content = ({
	children
}: ContentProps) => {
	return (
		<Grid2 size={12}>
			<Grid2
				container
				justifyContent="flex-start"
				alignItems="center"
			>
				{children}
			</Grid2>
		</Grid2>
	)
}